var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.00004,
    cy: 4.33341,
    r: 1.16667,
    stroke: "#A5A5AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.16675C9.5 5.7187 9.24462 6.38433 8.79405 7.10952C8.34981 7.8245 7.74953 8.54421 7.13676 9.19202C6.52583 9.83789 5.91319 10.4011 5.4524 10.8034C5.27592 10.9575 5.1222 11.0876 5 11.1892C4.8778 11.0876 4.72408 10.9575 4.5476 10.8034C4.08681 10.4011 3.47417 9.83789 2.86324 9.19202C2.25047 8.54421 1.65019 7.8245 1.20595 7.10952C0.755378 6.38433 0.5 5.7187 0.5 5.16675C0.5 2.68147 2.51472 0.666748 5 0.666748C7.48528 0.666748 9.5 2.68147 9.5 5.16675Z",
    stroke: "#A5A5AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bd0562cf5109e4136424cb781ca23250.svg";
export { ForwardRef as ReactComponent };